import { capitalize } from "lodash";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

export const ViewPaymentMethodModal = (props: any) => {
  const { isOpen, toggle, data } = props;
  const getPaymentInfoLabel = (value: string): string => {
    switch (value) {
      case "momo_number":
        return "Momo Number";
      case "provider":
        return "Provider";
      case "merchant_id":
        return "Merchant ID";
      case "account_name":
        return "Account Name";
      case "account_number":
        return "Account Number";
      case "bank_name":
        return "Bank Name";
      case "bank_branch":
        return "Bank Branch";
      default:
        return "Unknown";
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <h5 className="modal-title">Payment Method Details</h5>
      </ModalHeader>
      <ModalBody>
        <>
          <div className="mb-4">
            <div className="table-responsive">
              <Table className="table-borderless mb-0">
                <tbody>
                  <tr>
                    <th scope="row" style={{ width: "200px" }}>
                      ID :
                    </th>
                    <td>#{data?.id}</td>
                  </tr>
                  <tr>
                    <th scope="row">Name:</th>
                    <td>{data?.name}</td>
                  </tr>
                  <tr>
                    <th scope="row">Description:</th>
                    <td>{data?.description}</td>
                  </tr>
                  <tr>
                    <th scope="row">Status :</th>
                    <td>{capitalize(data?.status)}</td>
                  </tr>
                  <tr>
                    <th scope="row">Type:</th>
                    <td>{capitalize(data?.type)}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
            {data.payment_info && Object.keys(data.payment_info).length > 0 && (
              <div className="mt-4">
                <h6 className="mb-3">Payment Info:</h6>
                <div className="bg-light p-3 rounded">
                  <Table className="table-borderless mb-0">
                    <tbody>
                      {Object.entries(data.payment_info).map(([key, value]) => (
                        <tr key={key}>
                          <th scope="row" className="text-nowrap">
                            {getPaymentInfoLabel(key) || "Unknown"}:
                          </th>
                          <td>
                            {typeof value === "string" ||
                            typeof value === "number"
                              ? value
                              : capitalize(String(value))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </div>
        </>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
